import React from 'react';
import { FormGroup, FormSelect } from '@spotify-internal/encore-creator-web';
import { Language } from '../../../types';
import partition from 'lodash/partition';

const HighlightedLanguages = ['en', 'de', 'sv'];

interface Props {
  languages: Language[];
  value: string;
  onChange(language: Language): void;
}

export function LanguageField(props: Props) {
  function handleOnChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const code = event.target.value;
    const selectedLanguage = props.languages.find(language => language.code === code)!;
    props.onChange(selectedLanguage);
  }

  const [head, tail]: [Language[], Language[]] = partition(props.languages, (language: Language) =>
    HighlightedLanguages.includes(language.code),
  );

  return (
    <>
      <FormGroup
        label="Primary language spoken in your podcast"
        labelFor="language"
        indicator="required"
      >
        <FormSelect
          id="language"
          data-testid="language"
          onChange={handleOnChange}
          value={props.value}
        >
          <option value="" disabled>
            Select language
          </option>
          {head.map(language => (
            <option key={language.code} value={language.code}>
              {language.name}
            </option>
          ))}
          <option disabled>────────</option>
          {tail.map(language => (
            <option key={language.code} value={language.code}>
              {language.name}
            </option>
          ))}
        </FormSelect>
      </FormGroup>
    </>
  );
}
